import React from 'react';
import ReactDOM from 'react-dom';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
const DOM_ID = 'intelli-assistant';
export class RenderReactComponent {
    root;
    constructor(Comp, props, domId = DOM_ID) {
        let root = window.document.getElementById(domId);
        if (!root) {
            root = window.document.createElement('div');
            root.id = domId;
            root.setAttribute('data-xreplay-ignored', 'true');
            document.body.appendChild(root);
        }
        this.root = root;
        ReactDOM.render(React.createElement(Comp, { ...props }), root);
    }
    uninstall() {
        if (this.root) {
            this.root.parentNode?.removeChild(this.root);
            this.root = null;
        }
    }
}
/**
 * 通过入参获取默认位置
 * @param position  top | middle | bottom | xxpx |xx%
 * @param height  小灵快捷入口高度
 * @param padding  小灵默认padding值
 */
export function getDefaultPosition(position, height = 62, padding = 12, direction = 'normal') {
    const clientHeight = document.documentElement.clientHeight;
    let y = 0;
    const maxY = y;
    const minY = padding * 2 + height - clientHeight;
    const precentReg = /(\d+)%/;
    const pxReg = /(-?\d+)px/;
    if (position === 'bottom') {
        y = maxY;
    }
    if (position === 'middle') {
        y = height + padding - clientHeight / 2;
    }
    if (position === 'top') {
        y = minY;
    }
    if (precentReg.test(position)) {
        y =
            height +
                padding -
                clientHeight * (1 - Number(position.match(precentReg)?.[1]) / 100);
    }
    if (pxReg.test(position)) {
        const positionHeight = Number(position.match(pxReg)?.[1]);
        y = height + padding + positionHeight - clientHeight;
    }
    if (y >= maxY) {
        y = maxY;
    }
    if (y <= minY) {
        y = minY;
    }
    if (direction === 'reverse') {
        // console.log('y', y);
        y = minY - y;
    }
    return {
        x: 10,
        y,
    };
}
export function imgPreview(urls) {
    const id = 'cn-assistant-img-preview-dom';
    let dom = document.getElementById(id);
    if (!dom) {
        dom = document.createElement('div');
        document.body.appendChild(dom);
        dom.id = id;
    }
    // console.log('imgPreview', urls)
    if (!Array.isArray(urls)) {
        urls = [urls];
    }
    dom.style.height = '0px';
    dom.style.width = '0px';
    dom.innerHTML = urls.map(url => `<img data-src="${url}">`).join('');
    const viewer = new Viewer(dom, {
        url: 'data-src',
        hidden() {
            viewer.destroy();
        }
    });
    // console.log('viewer', viewer, urls);
    viewer.show();
    return viewer;
}
export function imgPreviewByDom(dom) {
    if (dom) {
        const imgList = Array.from(dom.querySelectorAll('img')).filter((img) => img.src);
        const imgUrls = imgList.map((img) => img.src);
        const onImgClick = (e) => {
            const img = e.target;
            const newImgList = [img.src, ...imgUrls.filter((item) => item !== img.src)];
            imgPreview(newImgList);
        };
        if (imgUrls.length) {
            imgList.forEach(img => {
                img.addEventListener('click', onImgClick);
            });
            return () => {
                imgList.forEach(img => {
                    img.removeEventListener('click', onImgClick);
                });
            };
        }
    }
    return () => { };
}
// @ts-ignore
window.imgPreview = imgPreview;
